import AbstractRuleTemplateAction from "./AbstractRuleTemplateAction.js";

/**
 * Null pattern object representing a non-existing action, like
 * removing a no rule template.
 */
export default class NullRuleTemplateAction extends AbstractRuleTemplateAction {
	constructor() {
		super({});
	}

	appendTo() {}

	perform() {}
}
